import { FC } from 'react'

type Emoji = {
  emoji: string
  label: string
}

const EmojiPicker: FC<{ onEmojiClick: (arg: Emoji) => void }> = ({ onEmojiClick }) => (
  <>
    <h2 className="mt-1 scrollable-modal-content">
      {animals.map((animal, index) => {
        return (
          <span className="cursor-pointer mr-2" key={`${index}-${animal.emoji}`} onClick={() => onEmojiClick(animal)}>
            {animal.emoji}
          </span>
        )
      })}
    </h2>
  </>
)

const animals: Emoji[] = [
  { emoji: '😃', label: 'smiling emoji' },
  { emoji: '🐒', label: 'monkey emoji' },
  { emoji: '🦍', label: 'gorilla emoji' },
  { emoji: '🐕', label: 'dog emoji' },
  { emoji: '🦊', label: 'fox emoji' },
  { emoji: '🦝', label: 'raccoon emoji' },
  { emoji: '🐈', label: 'cat emoji' },
  { emoji: '🦁', label: 'lion emoji' },
  { emoji: '🐯', label: 'tiger emoji' },
  { emoji: '🐴', label: 'horse emoji' },
  { emoji: '🦄', label: 'unicorn emoji' },
  { emoji: '🦓', label: 'zebra emoji' },
  { emoji: '🦌', label: 'deer emoji' },
  { emoji: '🐮', label: 'cow emoji' },
  { emoji: '🐷', label: 'pig emoji' },
  { emoji: '🐗', label: 'boar emoji' },
  { emoji: '🐏', label: 'ram emoji' },
  { emoji: '🐑', label: 'sheep emoji' },
  { emoji: '🐐', label: 'goat emoji' },
  { emoji: '🐪', label: 'dromedary emoji' },
  { emoji: '🐫', label: 'bactrian camel emoji' },
  { emoji: '🦙', label: 'llama emoji' },
  { emoji: '🐘', label: 'elephant emoji' },
  { emoji: '🦏', label: 'rhino emoji' },
  { emoji: '🦛', label: 'hippo emoji' },
  { emoji: '🐁', label: 'mouse emoji' },
  { emoji: '🐀', label: 'rat emoji' },
  { emoji: '🐹', label: 'hamster emoji' },
  { emoji: '🐰', label: 'rabbit emoji' },
  { emoji: '🦔', label: 'hedgehog emoji' },
  { emoji: '🦇', label: 'bat emoji' },
  { emoji: '🐻', label: 'bear emoji' },
  { emoji: '🐨', label: 'koala emoji' },
  { emoji: '🐼', label: 'panda emoji' },
  { emoji: '🦘', label: 'kangaroo emoji' },
  { emoji: '🦃', label: 'turkey emoji' },
  { emoji: '🐔', label: 'chicken emoji' },
  { emoji: '🐧', label: 'penguin emoji' },
  { emoji: '🕊', label: 'dove emoji' },
  { emoji: '🦅', label: 'eagle emoji' },
  { emoji: '🦆', label: 'duck emoji' },
  { emoji: '🦢', label: 'swan emoji' },
  { emoji: '🦉', label: 'owl emoji' },
  { emoji: '🦚', label: 'peacock emoji' },
  { emoji: '🦜', label: 'parrot emoji' },
  { emoji: '🐸', label: 'frog emoji' },
  { emoji: '🐊', label: 'crocodile emoji' },
  { emoji: '🐢', label: 'turtle emoji' },
  { emoji: '🦎', label: 'lizard emoji' },
  { emoji: '🐍', label: 'snake emoji' },
  { emoji: '🐉', label: 'dragon emoji' },
  { emoji: '🦖', label: 'dinosaur emoji' },
  { emoji: '🐳', label: 'whale emoji' },
  { emoji: '🐬', label: 'dolphin emoji' },
  { emoji: '🐟', label: 'fish emoji' },
  { emoji: '🐡', label: 'pufferfish emoji' },
  { emoji: '🦈', label: 'shark emoji' },
  { emoji: '🐙', label: 'ocotpus emoji' },
  { emoji: '🐌', label: 'snail emoji' },
  { emoji: '🦋', label: 'butterfly emoji' },
  { emoji: '🐜', label: 'ant emoji' },
  { emoji: '🐝', label: 'bee emoji' },
  { emoji: '🐞', label: 'ladybug emoji' },
  { emoji: '🕷', label: 'spider emoji' },
  { emoji: '🦂', label: 'scorpion emoji' },
  { emoji: '🦀', label: 'smiling emoji' },
  { emoji: '🦞', label: 'smiling emoji' },
  { emoji: '🦐', label: 'smiling emoji' },
  { emoji: '🦑', label: 'smiling emoji' }
]

export default EmojiPicker
